import Layout from 'Nori/Layout';
import Button from 'Nori/Button';
import SplitContent from 'Custom/Split/SplitContent';
import HeroQuestion from 'Custom/HeroQuestion';
import HeroFull from 'Nori/Hero/HeroFull';
import RichText from 'Custom/RichText';
import ItemBreakpoint from 'Custom/ItemBreakpoint';
import AjustableImage from 'Custom/AjustableImage';
import HERO_BG_IMAGE from 'Images/background/half-pink-marble.png';
import HERO_BG_IMAGE_MOBILE from 'Images/background/half-pink-marble-mobile.png';
import CIRCLE_IMAGE_DESKTOP from 'Images/misc/circle-arrows-desktop.webp';
import CIRCLE_IMAGE_MOBILE from 'Images/misc/circle-arrows-mobile.webp';
import BANNER_HEADING_DESKTOP from 'Images/headlines/pregnancy-after-nexplanon.svg';
import BANNER_HEADING_MOBILE from 'Images/headlines/pregnancy-after-nexplanon-mobile.svg';
import ARM_IMAGE_DESKTOP from 'Images/misc/arm-split-desktop.webp';
import ARM_IMAGE_MOBILE from 'Images/misc/arm-split-mobile.webp';
import styles from 'styles/pages/pregnancyAfterNexplanon.module.scss';

const HEAD = {
  title: 'Pregnancy After NEXPLANON® (etonogestrel implant) 68 mg Radiopaque',
  description:
    'NEXPLANON® (etonogestrel implant) 68 mg Radiopaque is reversible and removable anytime. Find out how soon pregnancy is possible after removal.',
  keywords: 'Pregnancy after Nexplanon, How soon can you get Pregnant after Nexplanon',
};

export default function Home() {
  const HeroBannerContent = () => (
    <div
      className={styles['content-wrap']}
      data-qa-tag="div-hero-banner-content"
    >
      <RichText data-qa-tag="richtext-hero-banner">
        <div
          className={styles.pregnancyAfterNexplanonPage}
          data-qa-tag="div-pregnancy-after-nexplanon"
        >
          <h4 data-qa-tag="heading-getting-pregnant-after-nexplanon">
            GETTING PREGNANT AFTER NEXPLANON
          </h4>

          <div
            className={styles.middleHeroText}
            data-qa-tag="div-middle-hero-text"
          >
            <ItemBreakpoint
              breakpoint="lg"
              type="max"
              data-qa-tag="item-breakpoint-banner-heading"
            >
              <BANNER_HEADING_DESKTOP data-qa-tag="image-banner-heading-desktop" />
              <BANNER_HEADING_MOBILE data-qa-tag="image-banner-heading-mobile" />
            </ItemBreakpoint>
          </div>

          <div
            className={styles.bottomHeroText}
            data-qa-tag="paragraph-bottom-hero-text"
          >
            NEXPLANON is reversible and can be removed by a trained healthcare
            professional at any time within 5 years.<sup>†</sup> Once you’ve
            made the decision, you could become pregnant as early as a week
            after the removal of NEXPLANON.
          </div>
          <p
            className={styles.captionText}
            data-qa-tag="paragraph-caption-text"
          >
            <sup>†</sup>NEXPLANON must be removed by the end of the fifth year.
          </p>
        </div>
      </RichText>
      <Button
        href="/removal/"
        data-qa-tag="button-learn-more-about-removal"
        data-design-type="clickAction"
        data-design-category="button_vd"
        data-design-action="Button"
        data-design-label="Learn more about removal"
        data-design-nori_id="Hero"
        data-design-module_name="GETTING PREGNANT AFTER NEXPLANON"
        data-design-module_no="01"
      >
        Learn More About Removal
      </Button>
    </div>
  );

  return (
    <Layout head={HEAD}>
      <div className={styles.heroWrapper}>
        <ItemBreakpoint breakpoint={'lg'}>
          <HeroFull
            image={HERO_BG_IMAGE}
            data-design-visible="visible_vd"
            data-design-type="module"
            data-design-nori_id="Hero"
            data-design-module_name="Pregnancy After NEXPLANON"
            data-design-module_no="01"
          >
            <HeroBannerContent />
          </HeroFull>
          <HeroFull
            image={HERO_BG_IMAGE_MOBILE}
            data-design-visible="visible_vd"
            data-design-type="module"
            data-design-nori_id="Hero"
            data-design-module_name="Pregnancy After NEXPLANON"
            data-design-module_no="01"
            data-qa-tag="hero-full-mobile"
          >
            <HeroBannerContent />
          </HeroFull>
        </ItemBreakpoint>
      </div>

      <SplitContent
        data-qa-tag="splitcontent-removal-info"
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="how is NEXPLANON removed?"
        data-design-module_no="02"
      >
        <ItemBreakpoint
          breakpoint="lg"
          data-qa-tag="item-breakpoint-removal-images"
        >
          <AjustableImage
            size="full"
            image={{ src: CIRCLE_IMAGE_DESKTOP, style: { width: 292 }, alt: '' }}
            data-qa-tag="image-circle-desktop"
          />
          <AjustableImage
            size="full"
            image={{ src: CIRCLE_IMAGE_MOBILE, alt: '' }}
            data-qa-tag="image-circle-mobile"
          />
        </ItemBreakpoint>
        <>
          <RichText data-qa-tag="richtext-removal-info">
            <h2 data-qa-tag="heading-how-is-nexplanon-removed">
              How is NEXPLANON removed?
            </h2>
            <p data-qa-tag="paragraph-removal-step-1">
              A trained healthcare professional can remove NEXPLANON in the
              office.
            </p>
            <p data-qa-tag="paragraph-removal-step-2">
              Removal of NEXPLANON involves a minor surgical procedure by a
              trained healthcare professional through a small incision in your
              arm where NEXPLANON is located.
            </p>
            <p data-qa-tag="paragraph-removal-step-3">
              After the implant is removed, the trained healthcare professional
              will put on an adhesive bandage and then apply a pressure bandage
              to minimize bruising.
            </p>
            <p data-qa-tag="paragraph-removal-step-4">
              A trained healthcare professional will cover the site where
              NEXPLANON was placed with 2 bandages. Leave the top bandage on for
              24 hours. Keep the bottom bandage clean, dry, and in place for 3
              to 5 days.
            </p>
          </RichText>
        </>
      </SplitContent>

      <SplitContent
        reverse
        data-qa-tag="splitcontent-replacement-info"
        backgroundColor={'colored'}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="NEXPLANON must be removed by the end of the third year. It can be replaced with a new implant during the same office visit."
        data-design-module_no="03"
      >
        <ItemBreakpoint breakpoint="md">
          <AjustableImage
            data-qa-tag="replacing-implant-arm-image-desktop"
            size="full"
            image={{ src: ARM_IMAGE_DESKTOP, style: { width: 292 }, alt: '' }}
          />
          <AjustableImage
            data-qa-tag="replacing-implant-arm-image-mobile"
            size="full"
            image={{ src: ARM_IMAGE_MOBILE, style: { width: 146 }, alt: '' }}
          />
        </ItemBreakpoint>
        <>
          <RichText data-qa-tag="richtext-replacement-info">
            <h2 data-qa-tag="heading-nexplanon-removal-timeline">
              NEXPLANON must be removed by the end of the fifth year. It can be
              replaced with a new implant during the same office visit.
            </h2>
            <p data-qa-tag="paragraph-replacement-step-1">
              A trained healthcare professional can remove the implant at any
              time within the 5-year period. Once it’s removed, a new implant
              can be inserted.
            </p>
            <p data-qa-tag="paragraph-replacement-step-2">
              Since the area has already been sterilized and numbing medication
              has been administered, a trained healthcare professional can
              insert a new NEXPLANON into the same area of your inner upper arm.
            </p>
            <p data-qa-tag="paragraph-replacement-step-3">
              Once inserted, both the patient and the trained healthcare
              professional will then feel the area to ensure the implant is
              placed correctly. If it is, the healthcare professional will cover
              the site where NEXPLANON was placed with 2 bandages. Leave the top
              bandage on for 24 hours. Keep the bottom bandage clean, dry, and
              in place for 3 to 5 days.
            </p>
          </RichText>
        </>
      </SplitContent>
      <HeroQuestion moduleNo="04" data-qa-tag="hero-question-section" />
    </Layout>
  );
}
